import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { generatePath, useParams } from 'mini-react-router-dom';
import { isFeatureEnabled } from 'owa-feature-flags';
import { joinPath, type MailRoutes } from 'mini-routes';
import { logCoreUsage } from 'owa-analytics';
import { useEffect } from 'react';
import { useNavigate } from 'mini-react-router-dom';

export const MailPushNotificationReadingPaneRouteHandler = () => {
    const params = useParams() as {
        folderId: string;
        conversationId: string;
        itemId: string;
        immutableItemId: string;
    };
    const navigate = useNavigate();

    useEffect(() => {
        const {
            folderId,
            conversationId: rawConversationId,
            itemId: rawItemId,
            immutableItemId: rawImmutableId,
        } = params;
        // If we get restIds, we need to convert them to ewsIds. If they are already ewsIds, the following conversion will be a no-op.
        const conversationId = convertRestIdToEwsId(rawConversationId);
        const itemId = convertRestIdToEwsId(rawItemId);
        const immutableItemId = convertRestIdToEwsId(rawImmutableId);
        logCoreUsage('WebPush_MailRPLanded', { iId: itemId });

        navigate(generatePath('/:folderId', { folderId: folderId }), { replace: true });
        if (isItemView()) {
            const effectiveItemId = isFeatureEnabled('fwk-immutable-ids')
                ? immutableItemId
                : itemId;

            navigate(
                generatePath(joinPath('/:folderId', 'itemId/:id'), {
                    folderId: folderId,
                    id: encodeURIComponent(effectiveItemId),
                })
            );
        } else {
            navigate(
                generatePath(joinPath('/:folderId', 'id/:id'), {
                    folderId: folderId,
                    id: encodeURIComponent(conversationId),
                })
            );
        }
    }, [navigate, params]);

    return null;
};
